import { Avatar, Dropdown, Spin } from "antd";
import { logoutAPI } from "api/auth";
import useMediaQuery from "hook/useMediaQuery";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  HamburgerMenu,
  LogoutIcon,
  QuestionMarkIcon,
  UserHeadIcon,
} from "themes/Icon";
import ButtonComp from "themes/elements/Button";
import KeyboardComp from "themes/elements/KeyBoard";
import SearchComp from "themes/elements/Search";
import { retrieveToken, retrieveUserData } from "utils/cryptoStorage";
import logopath from "../../../../public/svg/logo.svg";

import { toast } from "react-toastify";
import style from "./top_nav.module.scss";

function TopNav({ setSideMenu }) {
  const userData = retrieveUserData();
  const token = retrieveToken("accessToken");

  const [isClickDisabled, setIsClickDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 991px)");
  const navigate = useNavigate();

  const handleLogout = async () => {
    setLoading(true);
    try {
      const response = await logoutAPI(userData.user_type, token);
      if (response.message) {
        localStorage.clear();
        toast.success(response.message);
        navigate("/login");
      }
    } catch (error) {
      toast.error("Logout failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const profileMenu = (
    <div className={style["profile-menu"]}>
      <div className={style["profile-header"]}>
        <Avatar
          size={48}
          src={userData?.user_image}
          style={!userData?.user_image ? { backgroundColor: "#FFECCA" } : {}}
        >
          {!userData?.user_image && <UserHeadIcon />}
        </Avatar>
        <div className={style["profile-info"]}>
          <div className={style["profile-name"]}>
            {userData?.admin_user_name || "Unknown User"}
          </div>
          {userData?.email && (
            <div className={style["profile-email"]}>{userData?.email}</div>
          )}
        </div>
      </div>

      <div className={style["profile-divider"]}></div>

      <div
        className={style["logout-item"]}
        onClick={handleLogout}
        disabled={loading}
      >
        {loading ? (
          <Spin size="small" style={{ marginRight: "8px" }} />
        ) : (
          <LogoutIcon style={{ marginRight: "8px" }} />
        )}
        {loading ? "Logging out..." : "Log out"}
      </div>
    </div>
  );

  return (
    <nav className={style["navbar-container"]}>
      <div className="flex align-end gap-3 justify-start">
        <ButtonComp
          className={style["hamburger-icon"]}
          onClick={() => {
            if (isClickDisabled) return;
            setSideMenu((prev) => !prev);
            setIsClickDisabled(true);
            setTimeout(() => {
              setIsClickDisabled(false);
            }, 500);
          }}
          height={20}
          bgNone
          icon={<HamburgerMenu />}
        />
        <Link href="/" className={style["logo-icon"]}>
          <img src={logopath} alt="logo" />
        </Link>
      </div>

      <SearchComp
        height={isDesktop ? 48 : 40}
        placeholder="Search something..."
        suffix={isDesktop ? <KeyboardComp /> : null}
      />

      <div className="flex align-end gap-3 justify-end">
        <ButtonComp
          height={40}
          variant="secondary"
          bgNone
          rounded
          icon={<QuestionMarkIcon />}
        />

        <Dropdown
          overlayStyle={{ marginTop: "14px" }}
          overlay={profileMenu}
          trigger={["click"]}
        >
          <div style={{ cursor: "pointer" }}>
            {userData?.admin_user_name && (
              <>
                {userData.user_image ? (
                  <Avatar size={40} src={userData.user_image} />
                ) : (
                  <Avatar size={40} style={{ backgroundColor: "#FFECCA" }}>
                    <UserHeadIcon />
                  </Avatar>
                )}
              </>
            )}
          </div>
        </Dropdown>
      </div>
    </nav>
  );
}

export default TopNav;
